<template>
  <div>
    <div :class="{ 'summar-box-2': isUi2 }">
          <div >
            <h3 class="list-name-container">List Usage</h3>
            <b-row>
              <b-col class="list-name-input-container">
                <b-form-select v-model="listUsage" class="custom-select-gray">
                  <option
                    v-for="item in listMultiplePrice"
                    :value="item.MultipleId"
                    :key="item.MultipleId"
                  >
                    Use list {{ item.Desc.toLowerCase() }}
                    <span>(+{{ item.price | numberFormat }})</span>
                  </option>
                </b-form-select>
              </b-col>
            </b-row>
          </div>
    </div>
  </div>
</template>

<script>
import priceHelp from "@/assets/priceHelp";

export default {
  components: {
  },
  data() {
    return {
      selected: 1,
    };
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listMultiplePrice() {
      if (
        this.$store.state.summary.UserPriceList &&
        this.$store.state.summary.UserPriceList.ListMultiplePrice
      ) {
        let lists = this.$store.state.summary.UserPriceList.ListMultiplePrice;
        let order = JSON.parse(JSON.stringify(this.$store.state.order));
        order.ListUsage = 1;
        let totalEstmCost = priceHelp.updatePrice(order).TotalEstmCost;
        for (let i = 0; i < lists.length; i++) {
          order.ListUsage = lists[i].MultipleId;
          order = priceHelp.updatePrice(order);
          lists[i].price =
            (order.ListUsage > 1 ? 1 : -1) *
            (order.TotalEstmCost - totalEstmCost);
        }
        return lists;
      } else {
        return [];
      }
    },
    listUsage: {
      get() {
        return this.$store.state.order.ListUsage;
      },
      set(val) {
        this.$store.commit("order/saveKey", ["ListUsage", val]);
        this.TotalEstmCost = this.order.TotalEstmCost;
        this.$store.dispatch("order/calculatePrice");
      },
    },
    order() {
      return this.$store.state.order;
    },
    created() {
      this.TotalEstmCost = this.order.TotalEstmCost;
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  font-size: 13px;
}
.demo-block {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  transition: 0.2s;
  width: 500px;
  margin-bottom: 10px;
  margin: 10px auto;
}
.list-name-container {
  margin-left: 16px;
  font-size: 1rem;
  color: #616161;
}

.custom-select-gray {
  width: 20rem;
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.list-name-input-container {
  margin-bottom: 16px;
  margin-left: 16px;
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MListUsage.vue